export type AUVersion = '26.2' | '26.3' | '26.4' | '26.5' | '26.6';

export const AU_VERSIONS: AUVersion[] = ['26.2', '26.3', '26.4', '26.5', '26.6'];
export const DEFAULT_AU_VERSION: AUVersion = AU_VERSIONS[AU_VERSIONS.length - 1];

// Map of feature key → minimum AU version required.
// Features absent from this map are available in all tracked versions.
export const FEATURE_VERSIONS: Record<string, AUVersion> = {
  // AU 26.6+
  'patch.cpat':                       '26.6', // Cloud Premigration Advisor Tool (download only)
  'patch.dbsat':                      '26.6', // DB Security Assessment Tool (download only)
  'patch.gi':                         '26.6', // GI gold image (replaces OCW keyword in 26.6+)
  'patch.exaqfsdp':                   '26.6', // Exadata Quarterly Full Stack Download Patch (download only)
  'patch.exapatchmgr':                '26.6', // Exadata Patch Manager (download only)
  'patch.oem':                        '26.6', // Oracle Enterprise Manager (download only, exclusive)

  // AU 26.5+
  'create_gold_image':                '26.5',
  'gold_image.security_patch_level':  '26.5',
  'patch.goldimage_mode':             '26.5', // GOLDIMAGE:<path> patch mode
  'patch.recommended_version':        '26.5', // RECOMMENDED:X.Y with pinned version

  // AU 26.4+
  'patch.sqlcl':                      '26.4', // SQLcl keyword in patch param
  'existing_target_home':             '26.4',

  // AU 26.3+
  'patch.ahf':                        '26.3',
  'patch.cvu':                        '26.3',
  'patch.tools':                      '26.3',
  'download_folder':                  '26.3', // param renamed from 'folder' in AU 26.3 (AUPG-5133)

  // AU 26.2+
  'gold_image':                       '26.2', // gold_image param (YES/NO/ALL/AUTO)
  'rac_rolling':                      '26.2',
  'drain_timeout':                    '26.2',
};

// Human-readable labels per version for UI display
export const AU_VERSION_LABELS: Record<AUVersion, string> = {
  '26.2': 'AU 26.2',
  '26.3': 'AU 26.3',
  '26.4': 'AU 26.4',
  '26.5': 'AU 26.5',
  '26.6': 'AU 26.6',
};

export function versionCompare(a: AUVersion, b: AUVersion): number {
  const [am, an] = a.split('.').map(Number);
  const [bm, bn] = b.split('.').map(Number);
  return am !== bm ? am - bm : an - bn;
}

export function featureAvailable(featureKey: string, version: AUVersion): boolean {
  const req = FEATURE_VERSIONS[featureKey];
  if (!req) return true;
  return versionCompare(version, req as AUVersion) >= 0;
}

// Returns the minimum required version for a feature key, or null if always available
export function featureRequiredVersion(featureKey: string): AUVersion | null {
  return (FEATURE_VERSIONS[featureKey] as AUVersion) ?? null;
}
